import { Component } from '@angular/core';
import { ColmecDiscountListConfigService } from '../../services/colmec-discount-list-config.service';
import { ColmecDiscountsService } from '../../services/colmec-discounts.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ColmecDiscountImportModalComponent } from './colmec-discount-import-modal/colmec-discount-import-modal.component';

@Component({
    selector: 'colmec-discounts',
    templateUrl: './colmec-discounts.component.html',
    styleUrls: ['./colmec-discounts.component.scss'],
    standalone: false
})
export class ColmecDiscountsComponent {

  public modalRef: Map<string, NgbModalRef> = new Map<string, NgbModalRef>();

  constructor(
    public colmecDiscountListConfigService: ColmecDiscountListConfigService,
    protected colmecDiscountsService: ColmecDiscountsService,
    protected ngbModal: NgbModal
  ){
    
  }

  export(){
    this.colmecDiscountsService.export().subscribe(_=>{})
  }

  import(){   
    const id = ColmecDiscountImportModalComponent.name;

    const ref = this.ngbModal.open(ColmecDiscountImportModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    ref.componentInstance.delegate = this;

    this.modalRef.set(id, ref);

    return ref.result;
  }
}
